'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_magnolia1$002e$002dCase$002dClass$0024$002dParam from "./magnolia1.-Case-Class$-Param.js";
var $p;
/** @constructor */
function $c_Lmagnolia1_CaseClass$Param$$anon$2(name$2, idx$3, repeated$2, annotations$2, typeAnnotations$2, defaultVal$3, cbn$3, inheritedAnns$3) {
  this.Kp = null;
  this.Ko = null;
  this.Kq = 0;
  this.k7 = null;
  this.Kn = null;
  this.Kp = defaultVal$3;
  this.Ko = cbn$3;
  this.Kq = idx$3;
  this.k7 = name$2;
  this.Kn = annotations$2;
}
export { $c_Lmagnolia1_CaseClass$Param$$anon$2 as $c_Lmagnolia1_CaseClass$Param$$anon$2 };
$p = $c_Lmagnolia1_CaseClass$Param$$anon$2.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lmagnolia1_CaseClass$Param$$anon$2;
/** @constructor */
function $h_Lmagnolia1_CaseClass$Param$$anon$2() {
}
export { $h_Lmagnolia1_CaseClass$Param$$anon$2 as $h_Lmagnolia1_CaseClass$Param$$anon$2 };
$h_Lmagnolia1_CaseClass$Param$$anon$2.prototype = $p;
$p.b = (function() {
  return $j_magnolia1$002e$002dCase$002dClass$0024$002dParam.$f_Lmagnolia1_CaseClass$Param__toString__T(this);
});
$p.Ty = (function() {
  return this.Kp.lp();
});
$p.rq = (function() {
  return this.Ko.lp();
});
$p.xc = (function(value) {
  return value.g(this.Kq);
});
var $d_Lmagnolia1_CaseClass$Param$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lmagnolia1_CaseClass$Param$$anon$2, "magnolia1.CaseClass$Param$$anon$2", ({
  nN: 1,
  a: 1,
  e4: 1
}));
export { $d_Lmagnolia1_CaseClass$Param$$anon$2 as $d_Lmagnolia1_CaseClass$Param$$anon$2 };
